import { combineReducers } from 'redux';
import { baseLayers } from './baseLayers/reducer';
import { draw } from './draw/reducer';
import { map } from './map/reducer';
import { popup } from './mapPopup/reducer';
import { contextmenu } from './contextmenu/reducer';

const mainReducer = combineReducers({
  baseLayers,
  draw,
  map,
  popup,
  contextmenu
});

export default mainReducer;